import PropTypes from 'prop-types';
import { Button as AntButton } from 'antd';
import styled from 'styled-components';

const Styled = styled(AntButton)`
    padding: 6px !important;
    height: 32px !important;
    width: 32px !important;
    min-width: 32px !important;
    border-radius: 10px !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    color: ${({ theme }) => theme.colors.text.secondary} !important;

    &:hover {
        color: ${({ theme }) =>
            theme.colors.background.default === '#141414'
                ? 'rgba(255, 255, 255, 0.88)'
                : 'rgba(0, 0, 0, 0.88)'} !important;
        background: ${({ theme }) =>
            theme.colors.background.default === '#141414'
                ? 'rgba(255, 255, 255, 0.08)'
                : 'rgba(0, 0, 0, 0.04)'} !important;
    }

    &:active {
        background: ${({ theme }) =>
            theme.colors.background.default === '#141414'
                ? 'rgba(255, 255, 255, 0.12)'
                : 'rgba(0, 0, 0, 0.08)'} !important;
    }
`;

/**
 * Square ghost icon button for table row actions (edit/delete, etc.).
 */
export function GhostIconButton({ type = 'text', ...props }) {
    return <Styled type={type} {...props} />;
}

GhostIconButton.propTypes = {
    type: PropTypes.string,
};
